import axios from "axios";
import { TTP_API_URL } from "Config";

/*export const saveLike = ({ token, mediaId, isLike }) => {
  const requestUrl = `${TTP_API_URL}/media/like`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("objectType", "MEDIA");
  formData.append("objectId", mediaId);
  formData.append("isLike", isLike ? 1 : 0);

  return axios.post(requestUrl, formData);
};

export const saveFavorite = (token, mediaId) => {
  const requestUrl = `${TTP_API_URL}/media/favorite`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("objectType", "MEDIA");
  formData.append("objectId", mediaId);

  return axios.post(requestUrl, formData);
};*/

export const saveLike = ({
  token,
  objectId,
  isLike,
  objectType,
  organizationId
}) => {
  const requestUrl = `${TTP_API_URL}/media/like`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append(`${objectType.toLowerCase()}`, objectId);
  formData.append("organization", organizationId);
  formData.append("isLike", isLike ? 1 : 0);

  return axios.post(requestUrl, formData);
};

export const saveFavorite = ({
  token,
  objectId,
  objectType,
  organizationId
}) => {
  const requestUrl = `${TTP_API_URL}/media/favorite`;

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append(`${objectType.toLowerCase()}`, objectId);
  formData.append("organization", organizationId);

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/social.js